// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-save-search-box {
    height: 100%;
}

.modal-save-search-content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    height: 150px;
}

.save-search-field {
    width: 80%;
}

.save-search-actions-container {
    display: flex;
    width: 50%;
}

.save-search-modal-error-message-container {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
}

.error-icon {
    width: 0.7em;
    height: 0.7em;
}

@media (max-width: 992px) {
    .save-search-actions-container {
        width: 100%;
    }
}

@media (max-width: 700px) {
    .save-search-actions-container {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/searchResult/SearchResult.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".modal-save-search-box {\n    height: 100%;\n}\n\n.modal-save-search-content-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2rem;\n    height: 150px;\n}\n\n.save-search-field {\n    width: 80%;\n}\n\n.save-search-actions-container {\n    display: flex;\n    width: 50%;\n}\n\n.save-search-modal-error-message-container {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n}\n\n.error-icon {\n    width: 0.7em;\n    height: 0.7em;\n}\n\n@media (max-width: 992px) {\n    .save-search-actions-container {\n        width: 100%;\n    }\n}\n\n@media (max-width: 700px) {\n    .save-search-actions-container {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
